import React from "react"
import classNames from "classnames"
import { trim } from "lodash-es"

import { useTranslation } from "@/locales"
import Input from "../Input"
import InputAccount from "../InputAccount"

import styles from "./index.module.less"

interface Props {
    account: string
    smsCode: string
    smsCountDown: number
    onChange: ({
        account,
        smsCode,
    }: {
        account: string
        smsCode: string
    }) => void
    onKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => void
    onSendSmsCode: () => Promise<void>
}

const InputSmsCode: React.FC<Props> = (props) => {
    const { account, smsCode, smsCountDown, onChange, onKeyUp, onSendSmsCode } =
        props
    const { t } = useTranslation()

    return (
        <>
            <InputAccount
                scene="smsCode"
                value={account}
                onChange={(val) => onChange({ account: val, smsCode })}
                onKeyUp={onKeyUp}
            />
            <div className={styles.smsCodeRow}>
                <Input
                    className={styles.smsCode}
                    value={smsCode}
                    onChange={(e) =>
                        onChange({ account, smsCode: trim(e.target.value) })
                    }
                    onKeyUp={onKeyUp}
                    placeholder={t("login.placeholder.code")}
                />
                <div
                    className={classNames(
                        styles.sendSms,
                        smsCountDown && styles.disabled
                    )}
                    onClick={onSendSmsCode}
                >
                    {smsCountDown
                        ? `${t("login.code.resend")}(${smsCountDown})`
                        : t("login.code.send")}
                </div>
            </div>
        </>
    )
}

export default InputSmsCode
